<div *ngIf="title" class="total-block-header">{{ title | translate }}</div>
<div class="total-block" [ngClass]="{ 'border-botton-hide': hideBorderBottom }">
  <div class="row">
    <div class="col label">{{ "LABELS.GROSS_WEIGHT" | translate }}</div>
    <div class="col flex-grow-0 flex-shrink-0 text-nowrap value text-right bold">
      {{ commonGrossWeight | number : "1.2-2" }} {{ WEIGHT_UNIT_KG }}
    </div>
  </div>
  <div class="row">
    <div class="col label">{{ enteredValueTitle | translate }}</div>
    <div class="col flex-grow-0 flex-shrink-0 text-nowrap value text-right">
      <div class="bold">{{ commonValues * currencyRate | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</div>
      <div *ngIf="currency !== DEFAULT_CURRENCY_CODE" class="small">
        {{ commonValues | currency : currency : "" : "1.2-2" }} {{ currency }}
      </div>
    </div>
  </div>
</div>
